// src/components/AddEditPassenger.jsx
import React, { useState, useEffect } from "react";
import { GetUser } from "../../Services";

const AddEditPassenger = ({ editingPassenger, setEditingPassenger, setPassengers, setShowModal }) => {
  const passenger = Boolean(editingPassenger)
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
  });

  useEffect(() => {
    if (passenger) {
      setFormData({
        name: passenger.name || "",
        phone_number: passenger.phone_number || "",
        email: passenger.email || "",
      });
    }
  }, [passenger]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataCreate = new FormData();
      formDataCreate.append("formdata", JSON.stringify(formData));

      const updatedPassenger = editingPassenger
        ? await GetUser.PassengerUpdate(formDataCreate, editingPassenger.id)
        : await GetUser.PassengerCreate(formDataCreate);

      if (editingPassenger) {
        setPassengers((prev) =>
          prev.map((p) => (p.id === editingPassenger.id ? updatedPassenger.data : p))
        );
      } else {
        setPassengers((prev) => [updatedPassenger.data, ...prev]);
      }

      setShowModal(false);
      setEditingPassenger(null);
      setFormData({
        name: "",
        phone_number: "",
        email: "",
      });
    } catch (error) {
      console.error("Error saving passenger:", error);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <h2 className="text-xl font-semibold mb-4">
        {passenger ? "Edit Passenger" : "Add Passenger"}
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Name"
          className="form-control mb-2"
        />
        <input
          name="phone_number"
          value={formData.phone_number}
          onChange={handleChange}
          placeholder="Phone Number"
          className="form-control mb-2"
        />
        <input
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          className="form-control mb-2"
        />
        <button
          type="submit"
          className="btn btn-primary"        >
          {passenger ? "Update" : "Create"}
        </button>
      </form>
    </div>
  );
};

export default AddEditPassenger;
